import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  purple200,
  purple250,
  purple500,
  white100,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.Box {
    background-color: ${base_colorRaisedSurface};
    border-radius: ${spacing(2)};
    padding: ${spacing(5)} ${spacing(6)};
    box-sizing: border-box;

    /* Default variant - flat box with outline border, no shadow */
    &.default {
      border: 1px solid ${base_colorContentBorder};
    }

    /* Highlight variant - thicker purple border, purple background */
    &.highlight {
      border: 2px solid ${purple250};
      background-color: ${purple200};
    }

    /* HighlightContent variant - thicker purple border, white background */
    &.highlightContent {
      border: 2px solid ${purple250};
      background-color: ${white100};
    }

    /* Optional: no padding */
    &.noPadding {
      padding: 0;
    }

    /* Optional: custom padding */
    &.customPadding {
      /* Custom padding will be applied via inline style */
    }

    /* Optional: clickable box */
    &.clickable {
      cursor: pointer;
      transition: border-color 150ms ease-out;

      &:hover {
        border-color: ${purple500};
      }
    }
  }
`
